import { useDispatch as useDispatchBase, useSelector as useSelectorBase } from 'react-redux'
import { RematchDispatch, RematchRootState, RematchStore } from '@rematch/core'
import { RootModel } from '@/models'

export type Store = RematchStore<RootModel, Record<string, never>>
export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel>

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useDispatch = () => {
  return useDispatchBase<Dispatch>()
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useSelector = <T>(func: (state: RootState) => T) => {
  return useSelectorBase<RootState, T>(func)
}
